module.exports = __webpack_public_path__ + "img/red.db1e38f6.png";